import React from 'react';
import { Spinner } from 'react-bootstrap';
import { FocClear } from '~/components/Patient';
import { gapIsAddressed, gapIsUnderReview } from '~/util';

export interface FocGapModalFooterProps {
    focGap: GapType;
    rolePermission: boolean;
    formDirty: boolean;
    handleClose: () => void;
    formId: string;
    disabled: boolean;
    setDisabled: (x: boolean) => void;
    saving: boolean;
    tab: string;
    patientId: number;
}

export function FocGapModalFooter({
    focGap,
    rolePermission,
    formDirty,
    handleClose,
    formId,
    disabled,
    setDisabled,
    saving,
    tab,
    patientId,
}: FocGapModalFooterProps) {
    const hasSave =
        !rolePermission || gapIsAddressed(focGap) || gapIsUnderReview(focGap) ? false : formDirty;

    return (
        <>
            <button className="btn btn-secondary" type="button" onClick={handleClose}>
                {hasSave ? 'Cancel' : 'Close'}
            </button>
            <FocClear
                rolePermission={rolePermission}
                tab={tab}
                patientId={patientId}
                disabled={disabled}
                setDisabled={setDisabled}
                onSuccess={handleClose}
                focGap={focGap}
            />
            {hasSave && (
                <button
                    id="foc-gap-save"
                    className="btn btn-primary"
                    type="submit"
                    form={formId}
                    disabled={disabled}
                >
                    {saving && (
                        <Spinner animation="border" role="status" size="sm" className="me-1" />
                    )}
                    Save
                </button>
            )}
        </>
    );
}
